import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { DropdownItem } from '../models/dropdown-item';
import { CommonDataStore } from '../service/common-data/common-data.store';
import { PioneerValidators } from '../../shared/utils/pioneer.validators';
import { PropertyStore } from '../service/property/property.store';
import { Property } from '../models/property';
import { PropertyLookupStore } from 'app/shared/lookup/property-lookup/property-lookup.store';

@Component({
  selector: 'pioneer-vendor-add',
  templateUrl: './vendor-add.component.html',
  styleUrls: ['./vendor-add.component.css']
})
export class VendorAddComponent implements OnInit {

  propertyForm: FormGroup;

  states$: Observable<DropdownItem[]>;

  showState: boolean;

  showPostalCode: boolean;

  @Input('vendorSelected')
  public vendorSelected: string;

  get commonDataStore(): CommonDataStore {
    return this._commonDataStore;
  }

  @Output()
  canceled = new EventEmitter();

  @Output()
  accepted = new EventEmitter<Property>();

  private readonly propertyFormControlsConfig = {
    name: [ '', [ Validators.required, Validators.maxLength(50) ] ],
    countryCode: [ null, [ Validators.required ] ],
    address1: [ '', [ Validators.required, Validators.maxLength(50) ] ],
    address2: [ '', [ Validators.maxLength(50) ] ],
    address3: [ '', [ Validators.maxLength(50) ] ],
    city: [ '', [ Validators.required, Validators.maxLength(50) ] ],
    stateProvinceCode: [ null, [] ],
    postalCode: [ '', [ Validators.maxLength(15) ] ],
    contactFirstNm: [ '', [ Validators.maxLength(50) ] ],
    contactLastNm: [ '', [ Validators.maxLength(50) ] ],
    email: [ '', [ Validators.required, Validators.maxLength(75), PioneerValidators.isValidEmail ] ],
    phoneNr: [ '', [ Validators.maxLength(20) ] ],
    faxNr: [ '', [ Validators.maxLength(20) ] ],
    payorType: [ null, [ Validators.required ] ]
  };

  private readonly propertyFormValidators = {
    validator: Validators.compose([
      PioneerValidators.countryStateCrossValidator('countryCode', 'stateProvinceCode'),
      PioneerValidators.postalCodeCountryCrossValidator('postalCode', 'countryCode')
    ])
  };

  constructor(private formBuilder: FormBuilder,
              private _commonDataStore: CommonDataStore,
              public propertyLookupStore: PropertyLookupStore,
              private propertyStore: PropertyStore) {
  }

  ngOnInit() {
    this.reset();
  }

  reset() {
    this.showState = false;
    this.showPostalCode = false;
    this.states$ = Observable.of([]);
    if (!this.propertyForm) {
      this.createForm();
    } else {
      this.propertyForm.reset({
        name: '',
        countryCode: null,
        address1: '',
        address2: '',
        address3: '',
        city: '',
        stateProvinceCode: null,
        postalCode: '',
        contactFirstNm: '',
        contactLastNm: '',
        email: '',
        phoneNr: '',
        faxNr: ''
      });
    }
    this.propertyForm.enable();
  }

  cancel() {
    this.canceled.emit();
    this.reset();
  }

  accept(): void {
    this.propertyForm.disable();
    const propertyAddRequest = this.extractProperty();
    try {
      this.propertyStore.addVendor(propertyAddRequest).subscribe( (savedProperty) => {
        this.accepted.emit(savedProperty);
        this.reset();
      });
    } catch (error) {
      this.propertyForm.enable();
      Observable.throw(error);
    }
  }

  onCountryCodeChanged() {
    this.propertyForm.get('stateProvinceCode').reset();
    this.propertyForm.get('postalCode').reset('');
    this.states$ = this.commonDataStore.loadStatesFromCountry(this.propertyForm.get('countryCode').value);
    this.states$.take(1).subscribe((states: DropdownItem[]) => {
      this.showState = states.length > 0;
    });
    this.showPostalCode = PioneerValidators.isPostalCodeRequired(this.propertyForm, 'countryCode');
  }

  private createForm() {
    this.propertyForm = this.formBuilder.group(this.propertyFormControlsConfig, this.propertyFormValidators);
  }

  private extractProperty() {
    return new Property({
      id: null,
      chain: null,
      brand: null,
      pid: null,
      name: this.propertyForm.get('name').value,
      address1: this.propertyForm.get('address1').value,
      address2: this.propertyForm.get('address2').value,
      address3: this.propertyForm.get('address3').value,
      city: this.propertyForm.get('city').value,
      stateProvinceCode: this.propertyForm.get('stateProvinceCode').value,
      countryCode: this.propertyForm.get('countryCode').value,
      postalCode: this.propertyForm.get('postalCode').value,
      phoneNr: this.propertyForm.get('phoneNr').value,
      faxNr: this.propertyForm.get('faxNr').value,
      email: this.propertyForm.get('email').value,
      contactFirstNm: this.propertyForm.get('contactFirstNm').value,
      contactLastNm: this.propertyForm.get('contactLastNm').value,
      payorType: this.propertyForm.get('payorType').value
    });
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/vendor-add/vendor-add.component.ts